import React, { useState, useEffect } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import Header from "../../../Components/Header";
import Footer from "../../../Components/Footer";
import "../Account.css";
import { FaUserCircle, FaAngleRight } from 'react-icons/fa';
import SweetAlert from "react-bootstrap-sweetalert";
import { BrowserView, MobileView } from "react-device-detect";

const AccountSidebar = () => {

    const [user, setUser] = useState(null);
    const [showLogoutAlert, setShowLogoutAlert] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        const userData = localStorage.getItem("USER_DATA");
        if (userData) {
            setUser(JSON.parse(userData));
        }
    }, []);


    const handleLogoutClick = () => {
        setShowLogoutAlert(true);
    };

    const confirmLogout = () => {
        setShowLogoutAlert(false);
        handleLogout();
        navigate("/")
    };

    const handleLogout = () => {
        localStorage.removeItem("USER_DATA");
        setUser(null);
    };

    return (
        <>

            <BrowserView>

                <div className="account-container">
                    {/* Sidebar */}
                    <div className="account-sidebar">
                        <div className="user-info" style={{ width: "250px" }}>
                            <i className="fa fa-user-circle"></i>
                            <div>
                                <p className="username">Hi! {user?.username}</p>
                                <p className="email">{user?.email}</p>
                            </div>
                        </div>

                        <ul style={{ listStyleType: 'none', padding: 0 }}>
                            <li style={{ marginBottom: '5px' }}>
                                <Link to="/account" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: '#fff' }}>
                                    Account Overview
                                    <FaAngleRight style={{ marginLeft: 'auto', color: '#fff' }} />
                                </Link>
                            </li>
                            <li style={{ marginBottom: '5px' }}>
                                <Link to="/account/my-profile" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: '#fff' }}>
                                    My Profile
                                    <FaAngleRight style={{ marginLeft: 'auto', color: '#fff' }} />

                                </Link>
                            </li>
                            <li style={{ marginBottom: '5px' }}>
                                <Link to="/account/my-bookings" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: '#fff' }}>
                                    My Bookings
                                    <FaAngleRight style={{ marginLeft: 'auto', color: '#fff' }} />
                                </Link>
                            </li>
                            <li style={{ marginBottom: '5px' }}>
                                <Link to="/account/wallet" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: '#fff' }}>
                                    My Wallet
                                    <FaAngleRight style={{ marginLeft: 'auto', color: '#fff' }} />

                                </Link>
                            </li>

                            <li style={{ marginBottom: '5px' }}>
                                <Link to="/account/change-password" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: '#fff' }}>
                                    Change Password
                                    <FaAngleRight style={{ marginLeft: 'auto', color: '#fff' }} />

                                </Link>
                            </li>

                            <li style={{ marginBottom: '5px' }}>
                                <Link to="/account/help-support" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: '#fff' }}>
                                    Help & Support
                                    <FaAngleRight style={{ marginLeft: 'auto', color: '#fff' }} />

                                </Link>
                            </li>

                        </ul>

                        <button className="btn btn-danger mt-3" onClick={handleLogoutClick}>
                            <i className="fa fa-sign-out-alt me-2"></i>Logout</button>
                    </div>


                </div>

            </BrowserView>

            <MobileView>
                <div className="account-sidebar">
                    <div className="user-info">
                        <i className="fa fa-user-circle"></i>
                        <div>
                            <p className="username">Hi! {user?.username}</p>
                            <p className="email">{user?.email}</p>
                        </div>
                    </div>

                    <ul style={{ listStyleType: 'none', padding: 0 }}>
                        <li style={{ marginBottom: '5px' }}>
                            <Link to="/account" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: '#fff' }}>
                                Account Overview
                                <FaAngleRight style={{ marginLeft: 'auto', color: '#fff' }} />
                            </Link>
                        </li>
                        <li style={{ marginBottom: '5px' }}>
                            <Link to="/account/my-profile" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: '#fff' }}>
                                My Profile
                                <FaAngleRight style={{ marginLeft: 'auto', color: '#fff' }} />

                            </Link>
                        </li>
                        <li style={{ marginBottom: '5px' }}>
                            <Link to="/account/my-bookings" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: '#fff' }}>
                                My Bookings
                                <FaAngleRight style={{ marginLeft: 'auto', color: '#fff' }} />
                            </Link>
                        </li>
                        <li style={{ marginBottom: '5px' }}>
                            <Link to="/account/wallet" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: '#fff' }}>
                                My Wallet
                                <FaAngleRight style={{ marginLeft: 'auto', color: '#fff' }} />

                            </Link>
                        </li>

                        <li style={{ marginBottom: '5px' }}>
                            <Link to="/account/change-password" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: '#fff' }}>
                                Change Password
                                <FaAngleRight style={{ marginLeft: 'auto', color: '#fff' }} />

                            </Link>
                        </li>

                        <li style={{ marginBottom: '5px' }}>
                            <Link to="/account/help-support" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: '#fff' }}>
                                Help & Support
                                <FaAngleRight style={{ marginLeft: 'auto', color: '#fff' }} />

                            </Link>
                        </li>




                    </ul>

                    <button className="btn btn-danger mt-3" onClick={handleLogoutClick}>
                        <i className="fa fa-sign-out-alt me-2 mb-2"></i>Logout</button>
                </div>
            </MobileView>


            {showLogoutAlert && (
                <SweetAlert
                    warning
                    showCancel
                    confirmBtnText="Yes, Logout"
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="secondary"
                    title="Are you sure?"
                    onConfirm={confirmLogout}
                    onCancel={() => setShowLogoutAlert(false)}
                    focusCancelBtn
                >
                    You will be logged out of your account.
                </SweetAlert>
            )}

        </>
    )
}

export default AccountSidebar
